import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { fetchStripeOnboardingLink } from 'src/api/stripe';

const StripeOnboarding = ({ companyId }) => {
    useEffect(() => {
        fetchStripeOnboardingLink(companyId).then(response => {
            window.location.href = response.onboardingLink;
        });
    }, []);

    return <></>;
};

StripeOnboarding.propTypes = {
    companyId: PropTypes.number.isRequired,
};

export default StripeOnboarding;
